module.exports = __webpack_public_path__ + "img/store_Foodpanda_brown.6de9bdf7.svg";